import { Button, Col, DatePicker, Form, Input, InputNumber, List, message, Modal, Popconfirm, Row, Select, Space, Table, Tooltip } from "antd";
import dayjs from "dayjs";
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { CalendarOutlined, DeleteOutlined, EditOutlined, FileTextOutlined } from "@ant-design/icons";
import { CSVLink } from "react-csv";
import { addEMI, deleteLoan, getAllLoan, updateLoan } from "../../redux/rtk/features/loan/loanSlice";
import { loadAllStaff } from "../../redux/rtk/features/user/userSlice";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";
dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.tz.setDefault("Asia/Kolkata");

function GetLoan() {
    const dispatch = useDispatch();
    const { list, loading } = useSelector((state) => state?.loan);
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingLoan, setEditingLoan] = useState(null);
    const staffList = useSelector((state) => state?.users?.list);

    const [isEMIModalOpen, setIsEMIModalOpen] = useState(false);
    const [emiData, setEmiData] = useState(null);
    const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
    const [scheduleData, setScheduleData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedMonth, setSelectedMonth] = useState(null);


    const handleMonthChange = (date) => {
        setSelectedMonth(date ? dayjs(date).format("YYYY-MM") : null);
    };

    useEffect(() => {
        dispatch(loadAllStaff({ status: true }));
    }, [dispatch]);

    console.log("list", list);

    useEffect(() => {
        dispatch(getAllLoan());
    }, [dispatch]);

    const formatDate = (date) => {
        console.log("dd", date);

        return dayjs(date)
            .hour(0)
            .minute(0)
            .second(0)
            .millisecond(0)
            .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
    };

    const handleEdit = (loan) => {
        setEditingLoan(loan);
        form.setFieldsValue({
            userId: loan.userId,
            startDate: dayjs(loan.startDate),
            loanAmount: loan.loanAmount,
            totalMonthReturn: loan.totalMonthReturn,
        });
        setIsModalOpen(true);
    };

    const handleUpdate = async () => {
        try {
            const values = await form.validateFields();

            const formattedValues = {
                ...values,
                startDate: formatDate(values.startDate),
            };

            await dispatch(updateLoan({ id: editingLoan.id, values: formattedValues }));
            setIsModalOpen(false);
            dispatch(getAllLoan());
        } catch (error) {
            console.error("Validation failed:", error);
        }
    };

    // const updateEMI = async (values) => {
    //     try {
    //         await dispatch(addEMI(values));
    //         setIsModalOpen(false);
    //         dispatch(getAllLoan());
    //     } catch (error) {
    //         console.error("Validation failed:", error);
    //     }
    // };

    const updateEMI = async (values) => {
        try {
            if (!values.loanId) {
                throw new Error("Loan ID is not provided.");
            }
            await dispatch(addEMI(values));
            setIsEMIModalOpen(false);
            dispatch(getAllLoan());
        } catch (error) {
            console.error("Validation failed:", error.message);
        }
    };


    const handleCancel = () => {
        setIsModalOpen(false);
        setEditingLoan(null);
    };


    const handleDelete = async (id) => {
        await dispatch(deleteLoan(id));
        dispatch(getAllLoan());
    };

    const handleEMI = (loan) => {
        setEditingLoan(loan);
        const emi = (loan.loanAmount / loan.totalMonthReturn).toFixed(2);
        setEmiData({
            employeeName: `${loan.user.firstName} ${loan.user.lastName}`,
            startDate: dayjs(loan.startDate).format("YYYY-MM-DD"),
            loanAmount: loan.loanAmount,
            totalMonthReturn: loan.totalMonthReturn,
            emi,
            currentDate: dayjs().format("YYYY-MM-DD"),
        });
        setIsEMIModalOpen(true);
    };

    const handleSchedule = (loan) => {
        if (loan.loanEMI.length === 0) {
            message.info("No EMI schedule available for this loan.");
            return;
        }

        setScheduleData(loan.loanEMI);
        setIsScheduleModalOpen(true);
    };

    const filteredLoans = (list ?? []).filter((loan) => {
        const loanMonth = dayjs(loan?.startDate).format("YYYY-MM");
        return (!selectedMonth || loanMonth === selectedMonth) &&
               `${loan?.user?.firstName || ""} ${loan?.user?.lastName || ""}`
                   .toLowerCase()
                   .includes(searchTerm.toLowerCase());
    });
    
    // const filteredLoans = list.filter((loan) => {
    //     const loanMonth = dayjs(loan.startDate).format("YYYY-MM");
    //     return (!selectedMonth || loanMonth === selectedMonth) &&
    //            `${loan?.user?.firstName} ${loan?.user?.lastName}`
    //                .toLowerCase()
    //                .includes(searchTerm.toLowerCase());
    // });
    

    // const csvData = list.map((loan) => ({
    //     EmployeeName: `${loan.user.firstName} ${loan.user.lastName}`,
    //     StartDate: dayjs(loan.startDate).utc().format("DD-MM-YYYY"),
    //     LoanAmount: loan.loanAmount,
    //     TotalMonthReturn: loan.totalMonthReturn,
    //     Balance: loan.balance,
    // }));

    const csvData = (list ?? []).flatMap((loan) =>
        (loan.loanEMI ?? []).map((emi) => ({
            EmployeeName: `${loan?.user?.firstName || ""} ${loan?.user?.lastName || ""}`,
            StartDate: dayjs(loan?.startDate).utc().format("DD-MM-YYYY"),
            LoanAmount: loan?.loanAmount || 0,
            TotalMonthReturn: loan?.totalMonthReturn || 0,
            Balance: loan?.balance || 0,
            EmiAmount: emi?.EmiAmount || 0,
            EmiDate: dayjs(emi?.EmiDate).utc().format("DD-MM-YYYY"),
            EmiBalance: emi?.balance || 0,
        }))
    );
    

    const filteredCsvData = filteredLoans.flatMap((loan) => {
        if (loan.loanEMI.length === 0) {
            // If no EMI data, include only loan details with empty EMI fields
            return [{
                EmployeeName: `${loan.user.firstName} ${loan.user.lastName}`,
                StartDate: dayjs(loan.startDate).utc().format("DD-MM-YYYY"),
                LoanAmount: loan.loanAmount,
                TotalMonthReturn: loan.totalMonthReturn,
                Balance: loan.balance,
                EmiAmount: "N/A",
                EmiDate: "N/A",
                EmiBalance: "N/A",
            }];
        } else {
            // If EMI data exists, map as usual
            return loan.loanEMI.map((emi) => ({
                EmployeeName: `${loan.user.firstName} ${loan.user.lastName}`,
                StartDate: dayjs(loan.startDate).utc().format("DD-MM-YYYY"),
                LoanAmount: loan.loanAmount,
                TotalMonthReturn: loan.totalMonthReturn,
                Balance: loan.balance,
                EmiAmount: emi.EmiAmount,
                EmiDate: dayjs(emi.EmiDate).utc().format("DD-MM-YYYY"),
                EmiBalance: emi.balance,
            }));
        }
    });
    
    
    // const uniqueEmployeeNames = [...new Set(filteredLoans.map(loan => `${loan.user.firstName}_${loan.user.lastName}`))];

    // // Generate filename: If only one user, include their name; otherwise, keep it generic
    // const csvFilename = uniqueEmployeeNames.length === 1
    //     ? `loan_details_${uniqueEmployeeNames[0]}.csv`
    //     : "loan_details.csv";

    const columns = [
        {
            title: "S.No",
            dataIndex: "serial",
            key: "serial",
            render: (text, record, index) => index + 1

        },
        {
            title: "Employee Name",
            dataIndex: "user",
            key: "user",
            render: (user) => `${user.firstName} ${user.lastName}`,
        },
        // {
        //     title: "loan Name",
        //     dataIndex: "loanName",
        //     key: "loanName"
        // },
        {
            title: "Start Date",
            dataIndex: "startDate",
            key: "startDate",
            render: (startDate) => dayjs(startDate).utc().format("DD-MM-YYYY"),
        },
        {
            title: "loan Amount",
            dataIndex: "loanAmount",
            key: "loanAmount"
        },
        {
            title: "Total Month Return",
            dataIndex: "totalMonthReturn",
            key: "totalMonthReturn",
        },
        {
            title: "Balance",
            dataIndex: "balance",
            key: "balance",
        },

        {
            title: "Action",
            key: "action",
            render: (record) => (
                <Space>
                    <Tooltip title="Edit">
                        <Button type="primary" icon={<EditOutlined />} onClick={() => handleEdit(record)} />
                    </Tooltip>
                    <Tooltip title="EMI">
                        <Button type="default" icon={<FileTextOutlined />} onClick={() => handleEMI(record)} />
                    </Tooltip>
                    <Tooltip title="Schedule">
                        <Button type="dashed" icon={<CalendarOutlined />} onClick={() => handleSchedule(record)} />
                    </Tooltip>
                    <Popconfirm
                        title="Are you sure you want to delete this loan?"
                        onConfirm={() => handleDelete(record.id)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Tooltip title="Delete">
                            <Button type="danger" icon={<DeleteOutlined />} />
                        </Tooltip>
                    </Popconfirm>
                </Space>
            ),
        }
    ];


    return (

        <div>
            <Row justify="space-between" align="middle" className="mb-2">


                <Col>
                    <h2 style={{ fontSize: '16px', fontWeight: 'bold' }}>Loan Log</h2>
                </Col>
                <Space>
                    <DatePicker 
                        picker="month" 
                        onChange={handleMonthChange} 
                        placeholder="Filter by Month"
                    />
                    <Input
                        placeholder="Search by Employee Name"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </Space>
                <Col>
                    <CsvLinkBtn>
                        {/* <CSVLink
                            data={csvData}
                            className='btn btn-dark btn-sm'
                            style={{ marginTop: "5px" }}
                            filename='loan_details'>
                            Download CSV
                        </CSVLink> */}
                        <CSVLink
                            CSVLink data={filteredCsvData} filename='loan_details'>

                        
                            Download CSV
                        </CSVLink>

                    </CsvLinkBtn>
                </Col>
            </Row>
            <Table
                // columns={columns}
                // dataSource={list.map((item, index) => ({ ...item, serial: index + 1 }))}
                dataSource={filteredLoans} columns={columns} rowKey="id" />
            {/* loading={loading}
                rowKey="id"
            /> */}

            <Modal
                title="Edit Loan"
                visible={isModalOpen}
                onOk={handleUpdate}
                onCancel={handleCancel}
                okText="Update"
                cancelText="Cancel"
            >
                <Form form={form} layout="vertical">
                    <Form.Item
                        label="Employee"
                        name="userId"
                        rules={[{ required: true, message: "Please select an employee!" }]}
                    >
                        <Select placeholder="Select Employee" showSearch allowClear
                            filterOption={(input, option) =>
                                String(option.children).toLowerCase().includes(input.toLowerCase())
                            }>
                            {staffList?.map((staff) => (
                                <Select.Option key={staff.id} value={staff.id}>
                                    {/* {staff.userName} */}
                                    {`${staff.firstName} ${staff.lastName}`}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="Start Date"
                        name="startDate"
                        rules={[{ required: true, message: "Please select the start date!" }]}
                    >
                        <DatePicker format="YYYY-MM-DD" />
                    </Form.Item>
                    <Form.Item
                        label="Loan Amount"
                        name="loanAmount"
                        rules={[{ required: true, message: "Loan amount is required" }]}
                    >
                        <InputNumber />
                    </Form.Item>
                    <Form.Item
                        label="Total Month Return"
                        name="totalMonthReturn"
                        rules={[{ required: true, message: "Total month return is required" }]}
                    >
                        <InputNumber />
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title="EMI Details"
                visible={isEMIModalOpen}
                onCancel={() => setIsEMIModalOpen(false)}
                footer={[
                    <Button key="cancel" onClick={() => setIsEMIModalOpen(false)}>
                        Cancel
                    </Button>,
                    <Button
                        key="save"
                        type="primary"
                        onClick={() =>
                            updateEMI({
                                ...emiData,
                                loanId: editingLoan?.id, // Use editingLoan's ID
                            })
                        }
                    >
                        Save
                    </Button>,
                    // <Button key="save" type="primary" onClick={() => dispatch(updateEMI(emiData))}>
                    //     Save
                    // </Button>,
                ]}
            >
                <Form layout="vertical">
                    <Form.Item label="Employee Name">
                        <InputNumber value={emiData?.employeeName} disabled />
                    </Form.Item>
                    <Form.Item label="Start Date">
                        <DatePicker value={dayjs(emiData?.startDate)} disabled />
                    </Form.Item>
                    <Form.Item label="Loan Amount">
                        <InputNumber value={emiData?.loanAmount} disabled />
                    </Form.Item>
                    <Form.Item label="Total Month to Return">
                        <InputNumber value={emiData?.totalMonthReturn} disabled />
                    </Form.Item>
                    <Form.Item label="EMI">
                        <InputNumber
                            value={emiData?.emi}
                            onChange={(value) => setEmiData((prev) => ({ ...prev, emi: value }))}
                        />
                    </Form.Item>
                    <Form.Item label="EMI Date">
                        <DatePicker value={dayjs(emiData?.currentDate)} />
                    </Form.Item>
                </Form>
            </Modal>
            <Modal
                title="EMI Schedule"
                open={isScheduleModalOpen}
                onCancel={() => setIsScheduleModalOpen(false)}
                footer={[
                    <Button key="close" onClick={() => setIsScheduleModalOpen(false)}>Close</Button>
                ]}
            >
                <List
                    bordered
                    dataSource={scheduleData}
                    renderItem={(emi) => (
                        <List.Item>
                            <Row style={{ width: "100%" }} justify="space-between">
                                <Col><strong>EMI Amount:</strong> ₹{emi.EmiAmount}</Col>
                                <Col><strong>EMI Date:</strong> {dayjs(emi.EmiDate).format("DD-MM-YYYY")}</Col>
                                <Col><strong>Balance:</strong> ₹{emi.balance}</Col>
                            </Row>
                        </List.Item>
                    )}
                />
            </Modal>


        </div>
    );
}

export default GetLoan;
